import { EndpointBuilder } from "@reduxjs/toolkit/query";
import { sharedLib } from "@shared/services/shared.service";
import {
  BulkChangeNotificationActionRequest,
  ChangePlatformIsActiveRequest,
  GetNotificationsDataResponse,
  ApiGeneralDataResponse,
  ApiResponse,
  Notification,
  NotificationStatus,
} from "@shared/types";
import { getAggregateNotificationsArrays } from "@shared/features/notifications/utils";
import {
  updateNotificationsData,
  updateNotificationsPlatformsData,
} from "@shared/features/settings/utils";

export const notificationsEndpoints = {
  endpoints: (build: EndpointBuilder<any, any, any>) => ({
    getNotifications: build.query<Notification[][], void>({
      query: () => ({
        url: "get_notifications/",
        method: "POST",
      }),
      transformResponse: (response: { data: Notification[] }) => {
        return getAggregateNotificationsArrays(response.data);
      },
    }),
    markNotificationsRead: build.mutation<
      void,
      { notification_ids: number[] } | void
    >({
      query: (args) => ({
        url: "mark_notifications_read/",
        method: "POST",
        body: args,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            sharedLib.sharedApi.notifications.util.updateQueryData(
              "getNotifications",
              undefined,
              (notifications) => {
                return notifications.map((notification) => {
                  return notification.map((subItem) => {
                    if (
                      !args ||
                      args.notification_ids.includes(subItem.notification_id)
                    )
                      return {
                        ...subItem,
                        status: NotificationStatus.READ,
                      };
                    return subItem;
                  });
                });
              }
            )
          );
        } catch {}
      },
    }),
    getNotificationsData: build.query<GetNotificationsDataResponse, void>({
      query: () => ({
        url: "get_notifications_data/",
        method: "POST",
        body: { is_new_notifications_page: true },
      }),
      transformResponse: (response: { data: GetNotificationsDataResponse }) => {
        return response.data;
      },
    }),
    bulkChangeNotificationAction: build.mutation<
      void,
      BulkChangeNotificationActionRequest
    >({
      query: (args) => ({
        url: "bulk_change_notification_action/",
        method: "POST",
        body: args,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            updateNotificationsData(
              args.notification_action_types,
              args.telegram_coupling_type,
              args.is_active
            )
          );
        } catch {}
      },
    }),
    changePlatformIsActive: build.mutation<void, ChangePlatformIsActiveRequest>(
      {
        query: (args) => ({
          url: "change_platform_is_active/",
          method: "POST",
          body: args,
        }),
        async onQueryStarted(args, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled;
            dispatch(
              updateNotificationsPlatformsData(
                args.telegram_coupling_type,
                args.is_active
              )
            );
          } catch {}
        },
      }
    ),
    getShareTradeBannerImage: build.query<
      Record<number, string>,
      { trade_ids: number[] }
    >({
      query: (args) => ({
        url: "get_share_trade_banner_image/",
        method: "POST",
        body: args,
      }),
      transformResponse: (
        response: ApiResponse<ApiGeneralDataResponse<Record<number, string>>>
      ) => {
        return response.data?.data;
      },
    }),
  }),
};
